module.exports = __webpack_public_path__ + "static/media/tractor.90198936.svg";